module.exports = __webpack_public_path__ + "img/favicon-observer.4e0e7604.jpeg";